import { render, staticRenderFns } from "./ButtonLanguage.vue?vue&type=template&id=1b5b585c&scoped=true&"
import script from "./ButtonLanguage.vue?vue&type=script&lang=js&"
export * from "./ButtonLanguage.vue?vue&type=script&lang=js&"
import style0 from "./ButtonLanguage.vue?vue&type=style&index=0&id=1b5b585c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b5b585c",
  null
  
)

export default component.exports